
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import t from "@common/src/i18n/t";

const finance = namespace("finance");
const app = namespace("app");

@Component({})
export default class SmsVerification extends Vue {
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @finance.Action sendOtherDiscountValidationCode;
  @Prop({ default: t("v216_6.please-enter-the-sms-verification-code"), type: String })
  text: string;
  @Prop({ default: false, type: Boolean })
  visible: boolean;
  @Prop({ default: null, type: Function })
  sendCodeMethod: any;

  formData: any = {
    code: ""
  };
  status = "ready";
  counterNum = 60;
  formDataRules: any = {
    code: { required: true, message: t("v216_6.please-enter-the-sms-verification-code"), trigger: "change" }
  };
  handleSendCode() {
    if (this.status === "ready") {
      this.sendCodeMethod().then(data => {
        this.$message.success(data.message);
        this.startCountdown();
      });
    }
  }
  counterText = t("v213.Obtain-the-verification-code");
  timer: any = 0;
  startCountdown() {
    this.status = "countdown";
    this.counterText = `${this.counterNum}S${t("v210831.resend-sms")}`;
    this.timer = setInterval(() => {
      this.counterText = `${--this.counterNum}S${t("v210831.resend-sms")}`;
      console.log(76);
      if (this.counterNum <= 0) {
        this.reset();
      }
    }, 1000);
  }
  handleConfirm() {
    (this.$refs.form as any).validate(valid => {
      if (valid) {
        this.$emit("confirm", this.formData.code);
      }
    });
  }
  handleCancel() {
    this.reset();
    this.$emit("update:visible", false);
  }
  destroyed() {
    // 优化-销毁定时器
    this.timer && clearInterval(this.timer);
  }
  reset() {
    this.counterNum = 60;
    this.counterText = t("v213.Obtain-the-verification-code");
    this.status = "ready";
    this.timer && clearInterval(this.timer);
  }
}
